<template>
  <pulldown-page
    class="page"
    :background="background"
    color="#333333"
    :refresh="pulldown"
  >
    <template v-if="!fullProcess">
      <div class="interest-free">
        <img src="./images/icon_intrest_redpacket_banner.png" alt="banner" class="banner">
        <img :src="gmImg?require('./images/img_0@2x.png'):require('./images/icon_intrest_redpacket_bg.png')" alt="redpacket" class="redpacket">
        <section>
          <template v-if="isAndroid">
            <nd-button
              :class="gmImg?'button animation':'button'"
              @click="download"
            >下载{{ isIos === 'IOS' ? '天美钱包' : '天美贷' }}立即{{gmImg?"提现":"领取"}}
              <img
                class="hand"
                src="./images/img_shou.png"
                srcset="
                                  ./images/img_shou@2x.png 2x,
                                  ./images/img_shou@3x.png 3x
                              "
                v-if="!gmImg"
              />
            </nd-button>
          </template>
          <div class="list-item">
            <div class="item">
              <img
                src="./images/icon_01.png"
                srcset="
                                    ./images/icon_01@2x.png 2x,
                                    ./images/icon_01@3x.png 3x
                                "
              />
              <div class="text-1">快速审批</div>
              <div class="text-2">最快5分钟放款</div>
            </div>
            <div class="item">
              <img
                src="./images/icon_02.png"
                srcset="
                                    ./images/icon_02@2x.png 2x,
                                    ./images/icon_02@3x.png 3x
                                "
              />
              <div class="text-1">分期偿还</div>
              <div class="text-2">可分12期偿还</div>
            </div>
            <div class="item">
              <img
                src="./images/icon_03.png"
                srcset="
                                    ./images/icon_03@2x.png 2x,
                                    ./images/icon_03@3x.png 3x
                                "
              />
              <div class="text-1">放心使用</div>
              <div class="text-2">正规持牌机构</div>
            </div>
          </div>
        </section>
        <footer>
          <!-- ©️ 2017-2020 天美贷版权所有 -->
        </footer>

      </div>
      <section class="compliance">
        <p>贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准(综合年化利率区间15.4%-36%，单利计算)</p>
        <p>贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
      </section>
    </template>
    <template v-else>
      <div
        class="refused"
        v-if="
          [
            'CREDIT_ERROR',
            'CREDIT_EXPIRE',
            'CREDIT_REFUSED',
          ].includes(creditStatus)
        "
      >
        <div class="animation-wapper">
          <lottie ref="animataion" :options="showGif[1]"  v-on:animCreated="handleAnimation"/>
        </div>
        <h1>授信未通过</h1>
        <p v-if="!reapplyTime">
          很遗憾，您的授信申请暂未通过<br />请稍后重试
        </p>
        <p v-else>
          很遗憾，您的授信申请暂未通过<br />您可以于<span
            class="highlight"
          >{{
            reapplyTime && reapplyTime.replace(/-/g, '/')
          }}</span>发起重试
        </p>
        <button @click="backHome">返回首页</button>
      </div>
      <div class="refused" v-else-if="creditStatus === 'CREDIT_REVIEW'">
        <!-- <img
                    src="./images/img_chuli.png"
                    srcset="
                        ./images/img_chuli@2x.png 2x,
                        ./images/img_chuli@3x.png 3x
                    "
                /> -->
        <div v-if="isKingCard" class="king-wait">
          <div class="badge">
            插队申请中
          </div>
        </div>
        <div v-else class="animation-wapper">
          <lottie ref="animataion" :options="showGif[0]"  v-on:animCreated="handleAnimation"/>
        </div>
        <h1>授信审核中</h1>
        <p v-if="isKingCard">尊敬的会员，已为您启用VIP专属审核通道</p>
        <p v-else>我们正在加急为您审核，请您耐心等待</p>
        <button @click="backHome">返回首页</button>
      </div>
      <div class="pass" v-else-if="creditStatus === 'CREDIT_SUCCESS'">
        <div class="card">
          <img
            src="./images/img_tongguo.png"
            srcset="
                            ./images/img_tongguo@2x.png 2x,
                            ./images/img_tongguo@3x.png 3x
                        "
          />
          <h1 class="underline">恭喜您，</h1>
          <h1>
            获得额度<span class="bold">{{
              creditLimit | currency
            }}</span>
          </h1>
          <p>放款快，利率低，立即发起提现吧</p>
          <nd-button class="solid-button" @click="navigateToWithdraw">立即提现</nd-button>
          <button class="text-button" @click="backHome">
            返回首页
          </button>
        </div>
      </div>
    </template>
    <download-guide ref="downloadGuide"></download-guide>
    <ios-download v-model="downloadVisible"></ios-download>
    <nd-dialog v-model="dialog4" closeBtn :footer="false">
      <div class="service-dialog3">
        <div class="description">您当前如需使用权益功能，请更新至最新版本。 您可前往「天美贷-我的」点击「版本更新」进行升级。</div>
        <div class="flex">
          <nd-button class="btn small" @click="jumpHome">立即升级</nd-button>
        </div>
      </div>
    </nd-dialog>
  </pulldown-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from '@/assets/axios'
import { getKey, judgeClientSystem } from '@/assets/utils'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import DownloadGuide from './components/download-guide'
import Lottie from 'vue-lottie'
import { fail, wait } from '@/assets/json/index'
export default {
  components: { DownloadGuide, Lottie },
  name: 'authentication-result',
  customReadyNotify: true,
  data () {
    return {
      showVip: false, // 底部小美vip广告位显示
      showGif: [
        { animationData: wait },
        { animationData: fail, loop: false }
      ],
      applyNo: this.$route.query.applyNo,
      creditStatus: null,
      reapplyTime: null,
      creditLimit: 0,
      channel:
        this.$route.query.channel || getKey('channel') || 'official',
      fullProcess: true,
      isIos: judgeClientSystem(),
      couponStatus: null,
      day: 0,
      currentNode: null,
      animationSpeed: 1,
      dialog4: false, // 为了解决安卓页面兼容的问题，用户于老版本券包页面跳转及授信/提现结果页跳转进权益卡
      isVip: 0,
      isKingCard: false
    }
  },
  async created () {
    if (['h5-fz'].includes(this.channel.toLowerCase())) {
      this.fullProcess = false
    } else {
      await this.getProcessType()
      if (this.fullProcess || this.currentNode === 'CREDIT_RESULT') {
        await this.getCreditResult()
      }
    }
    await this.queryVipShow()
    const res = await this.memberInfo()
    if (res.success && res.data) {
      this.isVip = res.data.myMemberInfo && !!res.data.myMemberInfo.memberNo
    }
    this.$report({
      id: 10002,
      args: {
        screen: 'page_credit_result',
        position: this.creditStatus,
        target: this.isVip ? 'vip' : 'novip'
      }
    })
    await this.getMemberShipStatusX()
    this.$bus.$emit('ready')
  },
  computed: {
    ...mapState({
      hasJsBridge: (state) => state.hasJsBridge
    }),
    ...mapState('activities', {
      qualificationCoupon: (state) =>
        state.qualificationCoupon
          ? state.qualificationCoupon[0] || {}
          : {}
    }),
    gmImg () {
      return ['h5-gmql', 'h5-fz'].includes(this.channel.toLowerCase())
    },
    background () {
      return this.fullProcess ? '#fff' : '#f97378'
    },

    showActivity () {
      if (
        this.qualificationCoupon.qualification &&
        this.qualificationCoupon.couponStatus !== 'USED' &&
        ['CREDIT_REFUSED'].includes(this.creditStatus)
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('authentication', ['getCreditResultX']),
    ...mapActions('activities', ['couponListX', 'couponDetailX']),
    ...mapActions('vip', [
      'memberInfo',
      'getMemberShipStatus'
    ]),
    ...mapActions('user', [
      'showStatusX'
    ]),
    // 查询vip展示状态
    async queryVipShow () {
      const { success, data } = await this.showStatusX({
        rightsType: 'XM_VIP'
      })
      if (success) {
        this.showVip = data
      }
    },
    // 跳转首页
    jumpHome () {
      this.dialog4 = false
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      }
    },
    // 跳转权益卡vip界面
    jumpVip () {
      this.$report({
        id: 10161,
        args: {
          position: this.creditStatus,
          target: this.isVip ? 'vip' : 'novip'
        }
      })
      if (hasNativeMethod('getUserInfo') && judgeClientSystem() === 'Android' &&
        getKey('appVersion') && getKey('appVersion') < '1.7.4') {
          this.dialog4 = true
      } else {
        this.$router.push('/vip/index')
      }
    },
    handleAnimation (anim) {
      this.anim = anim
    },
    // 下拉刷新
    pulldown () {
      window.location.reload()
    },
    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },
    navigateToWithdraw () {
      this.$report({
        id: 10085
      })
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: true })
      } else {
        this.$router.push('/withdraw/index')
      }
    },
    async getProcessType () {
      const res = await axios.post('/order/v1/biz-route', {
        channelNo: this.channel
      })
      if (res.data.success) {
        this.fullProcess = !res.data.data.half
        this.currentNode = res.data.data.currentNode
      }
    },
    async getCreditResult () {
      if (!this.applyNo || this.applyNo === 'null' || ['h5-gmql'].includes(this.channel.toLowerCase())) {
        this.fullProcess = false
        return
      }
      this.fullProcess = true
      const res = await this.getCreditResultX({
        loanPlatform: 'TMD',
        applyNo: this.applyNo
      })
      if (res.success) {
        this.creditStatus = res.data.creditStatus
        const { meetSVIP, creditLimit, increaseLockAmount, showPassCardBuy } = res.data || {}

        if (showPassCardBuy === 'Y') {
          this.$router.replace(`/authentication/result-pass`)
          return
        }
        if (meetSVIP) {
          this.$router.replace({ path: '/ssvip/result', query: { creditLimit, increaseLockAmount } })
          return
        }
        if (this.creditStatus === 'UNCREDIT') {
          this.$router.push('/')
        }
        if (['CREDIT_REFUSED'].includes(this.creditStatus)) {
          this.$report({
            id: 10084,
            args: {
              status: 3,
              message: res.msg
            }
          })
          this.reapplyTime = res.data.reapplyTime
      
          if (this.qualificationCoupon.qualification) {
            this.$report({
              id: 10128,
              args: {
                status: this.qualificationCoupon
                  .couponDetailType
              }
            })
          }
        }
        if (this.creditStatus === 'CREDIT_SUCCESS') {
          this.creditLimit = res.data.creditLimit
          this.$report({
            id: 10084,
            args: {
              status: 1
            }
          })
        }
        if (this.creditStatus === 'CREDIT_REVIEW') {
          this.$report({
            id: 10084,
            args: {
              status: 2
            }
          })
        }
      }
    },
    async getCouponDetail () {
      const res = await this.couponListX({
        activeType: 'REDUCTION_INTEREST'
      })
      this.couponDetail = res.data[0] || {}
      this.couponStatus = this.couponDetail.status
      this.day = this.couponDetail.discountValue
    },
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('iframe')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.src = schema
        body.appendChild(node)
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    },

    download () {
      this.downloadApp()
    },
    // 去参加活动
    goActivity () {
      this.$report({
        id: 10129,
        args: {
          status: this.qualificationCoupon.couponDetailType
        }
      })
      this.$router.push({
        path: '/activities/compensation',
        query: {
          activeType: 'PAY_IF_REFUSE_NEW',
          loanPlatform: 'TMD',
          couponId: this.qualificationCoupon.couponRecordId
        }
      })
    },
 
    clickCloseHandler () {
      this.$report({ id: 50024 })
    },
    async getMemberShipStatusX () {
      const { success, data } = await this.getMemberShipStatus({
        memberTypes: ['KING']
      })
      if (success && data) {
        this.isKingCard = data.haveMember === 'Y'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.download-container {
    display: flex;
    align-items: center;
    width: 672px;
    margin: 0 auto;
    margin-bottom: 83px;
    height: 140px;
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 298px;
    border-radius: 20px;
    background: linear-gradient(
        90deg,
        rgba(255, 179, 92, 0.1) 0%,
        rgba(253, 122, 22, 0.1) 100%
    );
    &.showactivity {
        margin-top: 20px;
    }
    .logo {
        width: 80px;
        height: 80px;
        margin-right: 20px;
    }
    .text {
        flex: 1;
        > h1 {
            font-size: 30px;
            color: rgba(51, 51, 51, 1);
            line-height: 42px;
        }
        > p {
            font-size: 24px;
            color: rgba(102, 102, 102, 1);
            line-height: 33px;
        }
    }
    .button {
        width: 160px;
        height: 60px;
        line-height: 60px;
        background: linear-gradient(
            90deg,
            rgba(255, 179, 92, 1) 0%,
            rgba(253, 122, 22, 1) 100%
        );
        font-size: 28px;
        border-radius: 10px;
    }
}

.activity-container {
    display: flex;
    align-items: center;
    width: 672px;
    margin: 0 auto;
    height: 140px;
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 137px;
    border-radius: 20px;
    background: linear-gradient(
        90deg,
        rgba(255, 179, 92, 1) 0%,
        rgba(253, 122, 22, 1) 100%
    );
    .logo {
        width: 80px;
        height: 80px;
        margin-right: 20px;
    }
    .text {
        flex: 1;
        > h1 {
            font-size: 30px;
            color: #ffffff;
            line-height: 42px;
        }
        > p {
            font-size: 24px;
            color: #ffffff;
            line-height: 33px;
        }
    }
    .button {
        width: 160px;
        height: 60px;
        line-height: 60px;
        background: transparent;
        font-size: 28px;
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 1);
    }
}
.page {
    font-size: 28px;
    height: unset;

    .highlight {
        color: #ff4633 !important;
    }
    .bold {
        font-size: 72px;
        font-weight: 500;
        font-family: DIN-Medium, DIN; //需要引入字体文件
    }
    .refused {
        overflow: hidden;
        padding-top: 283px;
        > img {
            display: block;
            width: 190px;
            height: 190px;
            margin: 0px auto 50px;
        }
        .king-wait {
          width: 162px;
          height: 174px;
          margin: 0 auto;
          background: url(./images/img_wait_clean_king.png) no-repeat;
          background-size: 100%;
          margin-bottom: 20px;
          .badge {
            width: 150px;
            height: 46px;
            background: #FFE2BD;
            border-radius: 20px 100px 100px 0px;
            font-size: 24px;
            font-weight: 400;
            color: #763E12;
            line-height: 46px;
            text-align: center;
            position: absolute;
            top: 259px;
            left: 444px;
          }
        }
        .animation-wapper {
            height: 210px;
            width: 210px;
            margin: 0 auto;
        }
        > h1 {
            font-size: 42px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            text-align: center;
        }
        > p {
            margin-top: 15px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            text-align: center;
        }
        > button {
            display: block;
            width: 320px;
            height: 80px;
            margin: 66px auto 0;
            border-radius: 40px;
            border: 2px solid rgba(255, 70, 51, 1);
            background-color: #fff;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 70, 51, 1);
        }
    }
    .pass {
        height: 100vh;
        padding: 188px 45px;

        .card {
            overflow: hidden;
            position: relative;
            height: 100%;
            padding: 243px 73px 0;
            background: linear-gradient(
                180deg,
                rgba(255, 247, 237, 1) 0%,
                rgba(254, 254, 254, 1) 100%
            );
            border-radius: 30px;
            > img {
                position: absolute;
                top: -90px;
                right: -94px;
                width: 367px;
                height: 367px;
            }
            > h1 {
                font-size: 42px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 59px;
                margin-top: 30px;
                &.underline {
                    position: relative;
                    &::after {
                        position: absolute;
                        left: 0;
                        bottom: -10px;
                        content: '';
                        width: 130px;
                        height: 10px;
                        background: linear-gradient(
                            90deg,
                            rgba(255, 179, 92, 1) 0%,
                            rgba(253, 122, 22, 1) 100%
                        );
                    }
                }
            }
            > p {
                margin-top: 48px;
                font-size: 30px;
                color: rgba(102, 102, 102, 1);
            }
            .solid-button {
                display: block;
                width: 320px;
                height: 80px;
                line-height: 80px;
                border-radius: 40px;
                font-size: 32px;
                margin: 0 auto;
                margin-top: 74px;
                margin-bottom: 40px;
            }
            .text-button {
                display: block;
                width: 320px;
                font-size: 32px;
                color: rgba(255, 70, 51, 1);
                text-align: center;
                margin: auto;
                border: none;
                background: transparent;
            }
        }
    }
    .half-process {
        .header {
            width: 750px;
            height: 450px;
            margin: 0 auto;
            background-image: url(./images/half_result_header.png);
            background-size: 100%;
        }

        .half-content {
            background-color: #FAFAFA;
            padding: 50px;

            .credit-limit {
                text-align: center;
                padding-top: 50px;

                .text {
                    font-size: 34px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    color: #333333;
                    line-height: 48px;
                }

                .limit {
                    font-size: 112px;
                    font-family: DIN, DIN-Medium;
                    font-weight: 500;
                    color: #333333;
                    line-height: 136px;
                    margin-top: -20px;
                }
            }

            .download {
                text-align: center;

                .text-button {
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    color: #f5a166;
                    line-height: 40px;
                    margin-top: 50px;
                }

                .normal-button {
                    width: 650px;
                    height: 94px;
                    background: linear-gradient(90deg,#ff3333, #ff5f34);
                    border-radius: 47px;
                    margin-top: 44px;

                    .icon-arrow {
                        font-size: 32px;
                    }
                }
            }

            .product-feature {
                width: 650px;
                height: 210px;
                background: #ffffff;
                border-radius: 20px;
                box-shadow: 4px 6px 8px 8px rgba(243,243,243,0.5);
                padding: 35px 45px;
                margin-top: 94px;

                .feature-item {
                    font-size: 26px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #666666;
                    line-height: 37px;
                    position: relative;
                    padding-left: 30px;

                    & + .feature-item {
                        margin-top: 18px;
                    }

                    &::before {
                        content: '';
                        width: 14px;
                        height: 14px;
                        background-color: #F5A166;
                        position: absolute;
                        left: 0;
                        border-radius: 7px;
                        top: 10px;
                    }
                }
            }

            .copyright {
                text-align: center;
                height: 28px;
                font-size: 20px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                color: #999999;
                line-height: 28px;
                margin-top: 110px;

                span {
                    margin-left: 20px;
                }
            }
        }
    }
    footer{
        position: absolute;
        bottom:90px;
        left:40px;
        >img{
            width: 670px;
            height:170px;
        }
    }
}
.xiaohua {
    header {
        height: 490px;
        background: url(./images/bg_01@2x.png);
        background-size: 100% 100%;
        overflow: hidden;
        .slogan {
            display: flex;
            align-items: center;
            font-size: 28px;
            color: #ffffff;
            margin-top: 38px;
            padding: 0 38px;
            .logo {
                width: 48px;
                height: 48px;
                margin-right: 12px;
            }
        }
        .credit-limit {
            margin-top: 90px;
            text-align: center;
            color: #ffffff;
            &__text {
                font-size: 42px;
                line-height: 60px;
            }
            &__amount {
                font-size: 130px;
                font-family: DIN, DIN-Medium;
                font-weight: 500;
                line-height: 1;
                margin-top: -10px;
                .symbol {
                    font-size: 68px;
                }
            }
            &__tip {
                width: 330px;
                height: 48px;
                line-height: 48px;
                background: rgba(255, 212, 212, 0.25);
                border-radius: 5px;
                font-size: 22px;
                margin: 15px auto 0;
            }
        }
    }
    section {
        @keyframes hand {
            0% {
                transform: translateY(-15px);
            }
            50% {
                transform: translateY(15px);
            }
            100% {
                transform: translateY(-15px);
            }
        }
        .jujiupei {
            width: 540px;
            height: 187px;
            background: url(./images/jujiupei@2x.png) center center no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            margin: 97px auto 0;
            &__slogan {
                margin-top: 60px;
                padding-left: 163px;
                font-size: 36px;
                font-weight: 600;
                color: #333333;
                line-height: 50px;
            }
            &__tip {
                padding-left: 163px;
                font-size: 27px;
                color: #ff4633;
                line-height: 40px;
            }
        }
        .button {
            position: relative;
            width: 600px;
            height: 94px;
            line-height: 94px;
            margin: 60px auto 0;
            font-size: 36px;
            font-weight: 500;
            .hand {
                position: absolute;
                right: 13px;
                top: 50px;
                width: 100px;
                height: 110px;
                animation: hand 1s ease infinite;
            }
        }
        .list-item {
            display: flex;
            justify-content: space-between;
            padding: 0 60px;
            margin-top: 134px;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                > img {
                    width: 90px;
                    height: 90px;
                }
                .text-1 {
                    margin-top: 18px;
                    font-size: 28px;
                    text-align: center;
                    color: #333333;
                    line-height: 40px;
                }
                .text-2 {
                    font-size: 24px;
                    text-align: center;
                    color: #999999;
                    line-height: 40px;
                }
            }
        }
    }
    footer {
        margin-top: 130px;
        margin-bottom: 35px;
        font-size: 20px;
        text-align: center;
        color: #999999;
        line-height: 28px;
    }
}
.interest-free {
    // padding-bottom: 120px;
    .banner {
        width:750px;
        height:520px;
    }
    .redpacket {
        width:750px;
        height:420px;
        margin-top: -120px;
    }
    .button {
            position: relative;
            width: 600px;
            height: 94px;
            line-height: 94px;
            margin: 60px auto 0;
            font-size: 36px;
            font-weight: 500;
            .hand {
                position: absolute;
                right: 13px;
                top: 50px;
                width: 100px;
                height: 110px;
                animation: hand 1s ease infinite;
            }
        }
    .animation{
        animation: button 1.5s linear infinite;
    }
    @keyframes button {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(0.85);
        }
        100% {
            transform: scale(1);
        }
    }
    .list-item {
        display: flex;
        justify-content: space-between;
        padding: 0 60px;
        margin-top: 134px;
        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            > img {
                width: 90px;
                height: 90px;
            }
            .text-1 {
                margin-top: 18px;
                font-size: 28px;
                text-align: center;
                color: #333333;
                line-height: 40px;
            }
            .text-2 {
                font-size: 24px;
                text-align: center;
                color: #999999;
                line-height: 40px;
            }
        }
    }
    footer {
        // left: 50%;
        // transform: translateX(-50%);
        // position: fixed;
        // bottom: 36px;
        margin-bottom: 36px;
        font-size: 20px;
        text-align: center;
        color: #999999;
        margin-top: 79px;
        line-height: 28px;
    }
}
.compliance{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 160px;
    background: #FFFAF5;
    line-height: 160px;
    color: #D0BFB0;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    overflow: hidden;
    box-sizing: border-box;
    padding: 28px 30px;
    p {
        line-height: 1.6em;
    }
}
.service-dialog3{
    text-align: left;
    padding: 0 48px 38px;
    .description {
        margin-top:31px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    .thick{
    font-weight: 700 !important;
    }
    .btn {
        width: 300px;
        height: 80px;
        line-height: 80px;
        margin:40px auto 0;
    }
    .grey{
    background:white;
    color:#333;
    border:1px solid #333;
    margin:20px auto 0 !important;
    }
}
</style>
